import { getPanelOptions } from '../utils';
import RadioListComponent from '72cms-ui/components/form-elements/RadioListComponent';

export default {
    sections: ['details'],
    toolbar: ['add', 'edit', 'active', 'delete'],
    fields: {
        name: {
            section: 'details',
            position: 0,
        },
        type: {
            label: 'Choose panel type',
            section: 'details',
            position: 1,
            component: RadioListComponent,
            description: 'What type of panel is this?',
            values: function (value, schema, data) {
                const types = _.get(schema, 'values', [])
                    .filter(option => _.get(option, 'config.global'))
                    .map(option => option.id);

                return getPanelOptions(types);
            },
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/form.panel.js